const searchPageConstants = {
  SEARCH_START: "SEARCH_START",
  SEARCH_NO_RESULT_FOUND: "SEARCH_NO_RESULT_FOUND",
  SEARCH_SUCCEED: "SEARCH_SUCCEED",
  SEARCH_FAILED: "SEARCH_FAILED",
  SEARCH_FILTER_APPLY_CLICKED: "SEARCH_FILTER_APPLY_CLICKED",
  SEARCH_FILTER_CATEGORY_TOOGLED: "SEARCH_FILTER_CATEGORY_TOOGLED",
  SEARCH_FILTER_CATEGORY_SHOW: "SEARCH_FILTER_CATEGORY_SHOW",
  SEARCH_FILTER_CATEGORY_HIDE: "SEARCH_FILTER_CATEGORY_HIDE",
  SEARCH_FILTER_ITEM_TOOGLED: "SEARCH_FILTER_ITEM_TOOGLED",
  SEARCH_FILTER_VIEW_TOOGLED: "SEARCH_FILTER_VIEW_TOOGLED",
  SORT_VIEW_TOOGLED: "SORT_VIEW_TOOGLED",
  SORT_VIEW_SHOW: "SORT_VIEW_SHOW",
  SORT_VIEW_HIDE: "SORT_VIEW_HIDE",
  SEARCH_SORT_SET_SELECTION: "SEARCH_SORT_SET_SELECTION",
  SEARCH_FILTER_CLEAR_ALL: "SEARCH_FILTER_CLEAR_ALL",
  SEARCH_FILTER_CLEAR_SELECTED: "SEARCH_FILTER_CLEAR_SELECTED",
  SEARCH_PROMO_SUCCEED: "SEARCH_PROMO_SUCCEED",
  SEARCH_PROMO_FAILED: "SEARCH_PROMO_FAILED",
  SEARCH_INLINE_PROMO_SUCCEED: "SEARCH_INLINE_PROMO_SUCCEED",
  SEARCH_SEE_ALL_FILTERS: "SEARCH_SEE_ALL_FILTERS",
  SET_HOLIDAY_TAB: "SET_HOLIDAY_TAB",
}

export default searchPageConstants
